import {
  AfterViewInit,
  Component,
  Directive,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation
} from '@angular/core';

import {environment} from '../../../../../environments/environment';
import {language} from '../../../../language/vn';
import {CommandUtil} from '../../../../global/commandutil';
import {DatePipe} from '@angular/common';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {BsModalService} from 'ngx-bootstrap/modal';
import {ToastrService} from 'ngx-toastr';
import {YKienHoSoComponent} from './ykien.component';
import {NavItemService} from '../../../../service/staff/service-navitem';
import {YKTongHopHoSoComponent} from './tonghop.component';
import {FormatService} from '../../../../service/format/service-format';
import {HoSo} from '../../../../models/hoso/hoso';
import {HoSoFile} from '../../../../models/hoso/hosofile';
import {HoSoComment} from '../../../../models/hoso/hosocomment';
import {HoSoService} from '../../../../service/hoso/service-hoso';
import {HoSoFileService} from '../../../../service/hoso/service-hosofile';
import {HoSoCommentService} from '../../../../service/hoso/service-hosocomment';
import {FileHoSoComponent} from './file.componen';
import {DomSanitizer} from '@angular/platform-browser';
@Component({
  selector: 'xulyhoso-detail',
  templateUrl: './xulydetail.component.html',

})
export class XuLyDetailHoSoComponent implements OnInit, AfterViewInit {
  @Input() hoSoId: number = 0;
  @Output() backMethod: EventEmitter<string> = new EventEmitter();
  @Output() nextPage: EventEmitter<string> = new EventEmitter();
  @Output() backPage: EventEmitter<string> = new EventEmitter();
  public totalItems: number = 0;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public language = language;
  public showAction = true;
  public hoSoItem: HoSo = new HoSo();
  public hoSoFiles: HoSoFile[] = [];
  public hoSoCommentList: HoSoComment[]=[];
  public fileLists: Object[]=[];
  public maDonVi: number = Sessioncommand.maDonVi;
  public maNguoiXuLy: number = Sessioncommand.staffId;
  public permissionAdmin: boolean = false;
  public dateCurrent: Date = new Date();
  constructor(
    public hoSoService: HoSoService,
    public datepipe: DatePipe,
    public toastr: ToastrService,
    public commandUtil: CommandUtil,
    public hoSoFileService: HoSoFileService,
    public bsModalService: BsModalService,
    public hoSoCommentService: HoSoCommentService,
    public navItemService: NavItemService,
    public formatService: FormatService,
    public sanitizer: DomSanitizer
  ) {
  }
  ngAfterViewInit() {

  }

  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
  }
  public edit(id: number)
  {
    this.hoSoId = id;
    this.hoSoService.getById(id).subscribe(x => this.hoSoItem = x);
    this.hoSoFileService.findAllByHoSoId(id).subscribe( x => this.hoSoFiles = x);
    this.loadComment(this.hoSoId);

  }
  ngOnInit(): void {
    this.formatService.getCurrentDateVN().subscribe( x => this.dateCurrent = this.commandUtil.getDate(x));
    this.edit(this.hoSoId);
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId,"0001", true).subscribe(
      x => { this.permissionAdmin = x> 0? true: false;
      }
    );

  }
  public loadComment(id: number)
  {
    this.hoSoCommentService.getCountByKeyword(id, Sessioncommand.staffId).subscribe( data => this.totalItems = data);
    this.hoSoCommentService.findAllByPaging(id, Sessioncommand.staffId, this.currentPage, this.maxSize).subscribe( data => this.hoSoCommentList = data);
  }
  public yKienTongHop() {
    const modalEdit = this.bsModalService.show(YKTongHopHoSoComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<YKTongHopHoSoComponent>modalEdit.content).edit(
      this.hoSoId
    );
    (<YKTongHopHoSoComponent>modalEdit.content).onClose.subscribe(result => {
    });

  }
  public yKienXuLy() {
    const modalEdit = this.bsModalService.show(YKienHoSoComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<YKienHoSoComponent>modalEdit.content).edit(
      this.hoSoId
    );
    (<YKienHoSoComponent>modalEdit.content).onClose.subscribe(result => {
      this.edit(this.hoSoId);
    });

  }
  public thayFile(id: number) {
    const modalEdit = this.bsModalService.show(FileHoSoComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<FileHoSoComponent>modalEdit.content).edit(
      id
    );
    (<FileHoSoComponent>modalEdit.content).onClose.subscribe(result => {
      this.loadComment(this.hoSoId);
    });

  }
  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.loadComment(this.hoSoId);
  }
}

